const module = {
  config: {
    name: 'forums-archieve-module',
    icon: 'ri-user-line',
    desc: '',
    group: 'Postingan Diarsipkan',
    layout: true
  },
  routes: [
    { name: 'forums-archieve', label: 'Forum', icon: 'ri-file-text-line', path: '/forums-archieve', component: () => import('./forums-archieve.vue') }
    // { name: 'news', label: 'Berita', icon: 'ri-skip-right-fill', path: '/news', component: () => import('./users.vue') }
  ]
}
export default module



// WEBPACK FOOTER //
// ./src/modules/forums-archieve/_index.js